import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";

export const ForgotPasswordForm = ({ initialEmail, onBack }) => {
  const [email, setEmail] = useState(initialEmail || "");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="space-y-4">
        <p data-testid="forgot-password-sent" className="text-sm text-slate-600 dark:text-slate-300">
          Si ese correo tiene una cuenta, te llegará un enlace para crear una contraseña nueva. Caduca en 60 minutos.
        </p>
        <Button variant="outline" className="w-full" data-testid="forgot-back-to-login" onClick={onBack}>Volver a iniciar sesión</Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <Label htmlFor="fp-email">Correo electrónico</Label>
        <Input id="fp-email" type="email" required autoComplete="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </div>
      {error && <div data-testid="forgot-error" className="text-sm text-red-600">{error}</div>}
      <Button type="submit" data-testid="forgot-submit" className="w-full bg-[#026FCB] hover:bg-[#0358a5]" disabled={loading}>
        {loading ? "Enviando..." : "Enviar enlace"}
      </Button>
      <button type="button" data-testid="forgot-cancel" className="w-full text-sm text-[#026FCB] hover:underline" onClick={onBack}>Volver</button>
    </form>
  );
};
